import React, { useEffect, useContext, useState } from "react";
import CelebSidebar from "../../sidebar/index";
// import HeaderTwo from "../../fandashboard/newHeaderTwo";
import StickyBox from "react-sticky-box";
import Footer from "../../home/footer";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { getCelebIncomingRequests } from "../../../services/celebShoutouts";
import { doctordashboardprofile02 } from "../../imagepath";
import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
import Navbar from "../../landingpage/sections/Navbar/index.jsx";

const CelebCompletedOrders = (props) => {
    const { user, isAuthenticated } = useContext(AuthContext);
    const [completedOrders, setCompletedOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isAuthenticated && user?.userType === 'celeb') {
            fetchCompletedOrders();
        }
    }, [isAuthenticated, user]);

    const fetchCompletedOrders = async () => {
        try {
            setLoading(true);
            const response = await getCelebIncomingRequests();
            const requests = response.data.requests || [];

            // Filter only completed orders with video URLs
            const completed = requests
                .filter(request =>
                    (request.status === 'completed' || request.status === 'approved') &&
                    (request.shoutoutUrl || request.videoUrl || request.url)
                )
                .sort((a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt))
                .slice(0, 10); // Get top 10 most recent

            setCompletedOrders(completed);
        } catch (err) {
            setError(err.message || "Failed to fetch completed orders");
            console.error("Error fetching completed orders:", err);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const formatTime = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getYouTubeId = (url) => {
        if (!url) return null;
        if (url.includes('youtube.com/watch?v=')) {
            const videoId = url.split('v=')[1];
            const ampersandPosition = videoId.indexOf('&');
            return ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;
        } else if (url.includes('youtu.be/')) {
            return url.split('youtu.be/')[1];
        }
        return null;
    };

    const getVideoUrl = (order) => {
        return order?.shoutoutUrl || order?.videoUrl || order?.url;
    };

    if (loading) {
        return (
            <div className="main-wrapper">
                <Navbar {...props} />
                <div className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <StickyBox offsetTop={20} offsetBottom={20}>
                                    <CelebSidebar />
                                </StickyBox>
                            </div>
                            <div className="col-lg-8 col-xl-9">
                                <div className="dashboard-header">
                                    <div className="header-back">
                                        <h3>Finished Orders</h3>
                                    </div>
                                </div>
                                <div className="accunts-sec">
                                    <div className="account-detail-table">
                                        <div className="custom-new-table">
                                            <div className="text-center py-5">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="mt-3">Loading completed orders...</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer {...props} />
            </div>
        );
    }

    return (
        <div className="main-wrapper">
            <Navbar {...props} />

            {/* Breadcrumb */}
            <div className="breadcrumb-bar"
                style={{
                    backgroundColor: 'var(--breadcrumb-bg)',
                    transition: 'background-color 0.3s ease'
                }}
            >
                <div className="container">
                    <div className="row align-items-center inner-banner">
                        <div className="col-md-12 col-12 text-center">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/"><i className="isax isax-home-15" /></Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">
                                        Celeb
                                    </li>
                                    <li className="breadcrumb-item active">Finished Orders</li>
                                </ol>
                                <h2 className="breadcrumb-title">Finished Orders</h2>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-bg">
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-bg-01.png"
                        alt="img"
                        className="breadcrumb-bg-01"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-bg-02.png"
                        alt="img"
                        className="breadcrumb-bg-02"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-icon.png"
                        alt="img"
                        className="breadcrumb-bg-03"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-icon.png"
                        alt="img"
                        className="breadcrumb-bg-04"
                    />
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <StickyBox offsetTop={20} offsetBottom={20}>
                                <CelebSidebar />
                            </StickyBox>
                        </div>

                        <div className="col-lg-8 col-xl-9">
                            <div className="dashboard-header">
                                <div className="header-back">
                                    <Link to="/dashboard" className="back-arrow">
                                        <i className="fa-solid fa-arrow-left" />
                                    </Link>
                                    <h3>Finished Orders</h3>
                                </div>
                            </div>

                            <div className="accunts-sec">
                                {error && (
                                    <div className="alert alert-danger">
                                        <i className="fa-solid fa-exclamation-triangle me-2"></i>
                                        {error}
                                    </div>
                                )}

                                {completedOrders.length === 0 ? (
                                    <div className="account-detail-table">
                                        <div className="custom-new-table">
                                            <div className="table-header d-flex justify-content-between align-items-center mb-3">
                                                <h5>Finished Orders</h5>
                                            </div>
                                            <div className="text-center py-5">
                                                <i className="fa-solid fa-video-slash fa-3x text-muted mb-3"></i>
                                                <h4>No Finished Orders Yet</h4>
                                                <p className="text-muted">You haven't finished any orders with videos yet.</p>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="completed-orders-list">
                                        {completedOrders.map((order) => {
                                            const videoUrl = getVideoUrl(order);
                                            const isYouTube = videoUrl.includes('youtube.com/') || videoUrl.includes('youtu.be/');
                                            const youtubeId = isYouTube ? getYouTubeId(videoUrl) : null;

                                            return (
                                                <div key={order._id} className="appointment-wrap appointment-detail-card mb-4">
                                                    <div className="row">
                                                        <div className="col-md-8">
                                                            <ul>
                                                                <li>
                                                                    <div className="patinet-information">
                                                                        <img
                                                                            src={order.user?.profilepicture || doctordashboardprofile02}
                                                                            alt="Fan profile"
                                                                            style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '50%' }}
                                                                            onError={(e) => e.target.src = doctordashboardprofile02}
                                                                        />
                                                                        <div className="patient-info">
                                                                            <p>Order #: {order.shortoutId || order._id?.substring(0, 8)}</p>
                                                                            <h6>{order.user?.fullName || 'Unknown Fan'}</h6>
                                                                            <div className="mail-info-patient">
                                                                                <ul>
                                                                                    <li>
                                                                                        <i className="fa-solid fa-user" />
                                                                                        {order.user?.userPhone || 'Phone not provided'}
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li className="appointment-info">
                                                                    <div className="person-info">
                                                                        <p>Shoutout Details</p>
                                                                        <ul className="d-flex apponitment-types">
                                                                            <li>
                                                                                <i className="fa-solid fa-gift text-green" />
                                                                                For: {order.recipientName || "Special Recipient"}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li className="appointment-action">
                                                                    <div className="detail-badge-info">
                                                                        <span className="badge bg-success">
                                                                            {order.status?.toUpperCase()}
                                                                        </span>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <ul className="detail-card-bottom-info">
                                                                <li><h6>Delivery Date</h6><span>{formatDate(order.deliveryDate)}</span></li>
                                                                <li><h6>Delivery Time</h6><span>{formatTime(order.deliveryDate)}</span></li>
                                                                <li><h6>Completed On</h6><span>{formatDate(order.updatedAt)}</span></li>
                                                                {order.message && (
                                                                    <li><h6>Fan's Message</h6><span>{order.message}</span></li>
                                                                )}
                                                            </ul>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="video-preview-section">
                                                                <h6 className="mb-3">Video Shoutout</h6>

                                                                {isYouTube ? (
                                                                    <div style={{
                                                                        position: 'relative',
                                                                        paddingBottom: '56.25%', // 16:9 aspect ratio
                                                                        height: '0',
                                                                        overflow: 'hidden',
                                                                        borderRadius: '8px'
                                                                    }}>
                                                                        <iframe
                                                                            src={`https://www.youtube.com/embed/${youtubeId}`}
                                                                            title={`YouTube video for order ${order._id}`}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '0',
                                                                                left: '0',
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                border: 'none',
                                                                                borderRadius: '8px'
                                                                            }}
                                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                            allowFullScreen
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="text-center">
                                                                        <div style={{
                                                                            width: '100%',
                                                                            height: '140px',
                                                                            backgroundColor: '#007bff',
                                                                            borderRadius: '8px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            color: 'white',
                                                                            fontSize: '48px',
                                                                            marginBottom: '10px'
                                                                        }}>
                                                                            <i className="fa-solid fa-play"></i>
                                                                        </div>
                                                                        <a
                                                                            href={videoUrl}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="btn btn-primary btn-sm"
                                                                        >
                                                                            <i className="fa-solid fa-external-link-alt me-1"></i>
                                                                            View Video
                                                                        </a>
                                                                    </div>
                                                                )}

                                                                <div className="mt-3">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm"
                                                                        value={videoUrl}
                                                                        readOnly
                                                                        onClick={(e) => e.target.select()}
                                                                    />
                                                                    <small className="form-text text-muted">
                                                                        Click to copy video URL
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer {...props} />
        </div>
    );
};

export default CelebCompletedOrders;


// import React, { useEffect, useContext, useState } from "react";
// import CelebSidebar from "../../sidebar/index";
// import HeaderTwo from "../../fandashboard/newHeaderTwo";
// import StickyBox from "react-sticky-box";
// import Footer from "../../home/footer";
// import { Link } from "react-router-dom";
// import { AuthContext } from "../../../context/AuthContext";
// import { getCelebIncomingRequests } from "../../../services/celebShoutouts";
// import { doctordashboardprofile02 } from "../../imagepath";
// import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";


// const CelebCompletedOrders = (props) => {
//     const { user, isAuthenticated } = useContext(AuthContext);
//     const [completedOrders, setCompletedOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         if (isAuthenticated && user?.userType === 'celeb') {
//             fetchCompletedOrders();
//         }
//     }, [isAuthenticated, user]);

//     const fetchCompletedOrders = async () => {
//         try {
//             setLoading(true);
//             const response = await getCelebIncomingRequests();
//             const requests = response.data.requests || [];

//             // Filter only completed orders with video URLs
//             const completed = requests
//                 .filter(request =>
//                     (request.status === 'completed' || request.status === 'approved') &&
//                     (request.shoutoutUrl || request.videoUrl || request.url)
//                 )
//                 .sort((a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt))
//                 .slice(0, 10); // Get top 10 most recent

//             setCompletedOrders(completed);
//         } catch (err) {
//             setError(err.message || "Failed to fetch completed orders");
//             console.error("Error fetching completed orders:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return "N/A";
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: 'numeric'
//         });
//     };

//     const formatTime = (dateString) => {
//         if (!dateString) return "N/A";
//         const date = new Date(dateString);
//         return date.toLocaleTimeString('en-US', {
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     };

//     const getYouTubeId = (url) => {
//         if (!url) return null;
//         if (url.includes('youtube.com/watch?v=')) {
//             const videoId = url.split('v=')[1];
//             const ampersandPosition = videoId.indexOf('&');
//             return ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;
//         } else if (url.includes('youtu.be/')) {
//             return url.split('youtu.be/')[1];
//         }
//         return null;
//     };

//     const getVideoUrl = (order) => {
//         return order?.shoutoutUrl || order?.videoUrl || order?.url;
//     };

//     if (loading) {
//         return (
//             <div className="main-wrapper">
//                 <HeaderTwo {...props} />
//                 <div className="content">
//                     <div className="container-fluid">
//                         <div className="row">
//                             <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
//                                 <CelebSidebar />
//                             </div>
//                             <div className="col-lg-8 col-xl-9">
//                                 <div className="text-center py-5">
//                                     <div className="spinner-border text-primary" role="status">
//                                         <span className="visually-hidden">Loading...</span>
//                                     </div>
//                                     <p className="mt-3">Loading completed orders...</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <Footer {...props} />
//             </div>
//         );
//     }

//     return (
//         <div className="main-wrapper">
//             <HeaderTwo {...props} />

//             {/* Breadcrumb */}
//             <div className="breadcrumb-bar"
//                 style={{
//                     backgroundColor: 'var(--breadcrumb-bg)',
//                     transition: 'background-color 0.3s ease'
//                 }}
//             >
//                 <div className="container">
//                     <div className="row align-items-center inner-banner">
//                         <div className="col-md-12 col-12 text-center">
//                             <nav aria-label="breadcrumb" className="page-breadcrumb">
//                                 <ol className="breadcrumb">
//                                     <li className="breadcrumb-item">
//                                         <Link to="/"><i className="isax isax-home-15" /></Link>
//                                     </li>
//                                     <li className="breadcrumb-item" aria-current="page">
//                                         Celeb
//                                     </li>
//                                     <li className="breadcrumb-item active">Finished Orders</li>
//                                 </ol>
//                                 <h2 className="breadcrumb-title">Finished Orders</h2>
//                             </nav>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="breadcrumb-bg">
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-bg-01.png"
//                         alt="img"
//                         className="breadcrumb-bg-01"
//                     />
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-bg-02.png"
//                         alt="img"
//                         className="breadcrumb-bg-02"
//                     />
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-icon.png"
//                         alt="img"
//                         className="breadcrumb-bg-03"
//                     />
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-icon.png"
//                         alt="img"
//                         className="breadcrumb-bg-04"
//                     />
//                 </div>
//             </div>
//             {/* /Breadcrumb */}

//             <div className="content">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
//                             <StickyBox offsetTop={20} offsetBottom={20}>
//                                 <CelebSidebar />
//                             </StickyBox>
//                         </div>

//                         <div className="col-lg-8 col-xl-9">
//                             <div className="dashboard-header">
//                                 <div className="header-back">
//                                     <Link to="/dashboard" className="back-arrow">
//                                         <i className="fa-solid fa-arrow-left" />
//                                     </Link>
//                                     <h3>Finished Orders</h3>
//                                 </div>
//                             </div>

//                             {error && (
//                                 <div className="alert alert-danger">
//                                     <i className="fa-solid fa-exclamation-triangle me-2"></i>
//                                     {error}
//                                 </div>
//                             )}

//                             {completedOrders.length === 0 ? (
//                                 <div className="text-center py-5">
//                                     <i className="fa-solid fa-video-slash fa-3x text-muted mb-3"></i>
//                                     <h4>No Finished Orders Yet</h4>
//                                     <p className="text-muted">You haven't finished any orders with videos yet.</p>
//                                 </div>
//                             ) : (
//                                 <div className="completed-orders-list">
//                                     {completedOrders.map((order) => {
//                                         const videoUrl = getVideoUrl(order);
//                                         const isYouTube = videoUrl.includes('youtube.com/') || videoUrl.includes('youtu.be/');
//                                         const youtubeId = isYouTube ? getYouTubeId(videoUrl) : null;

//                                         return (
//                                             <div key={order._id} className="appointment-wrap appointment-detail-card mb-4">
//                                                 <div className="row">
//                                                     <div className="col-md-8">
//                                                         <ul>
//                                                             <li>
//                                                                 <div className="patinet-information">
//                                                                     <img
//                                                                         src={order.user?.profilepicture || doctordashboardprofile02}
//                                                                         alt="Fan profile"
//                                                                         style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '50%' }}
//                                                                         onError={(e) => e.target.src = doctordashboardprofile02}
//                                                                     />
//                                                                     <div className="patient-info">
//                                                                         <p>Order #: {order.shortoutId || order._id?.substring(0, 8)}</p>
//                                                                         <h6>{order.user?.fullName || 'Unknown Fan'}</h6>
//                                                                         <div className="mail-info-patient">
//                                                                             <ul>
//                                                                                 <li>
//                                                                                     <i className="fa-solid fa-user" />
//                                                                                     {order.user?.userPhone || 'Phone not provided'}
//                                                                                 </li>
//                                                                             </ul>
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
//                                                             </li>
//                                                             <li className="appointment-info">
//                                                                 <div className="person-info">
//                                                                     <p>Shoutout Details</p>
//                                                                     <ul className="d-flex apponitment-types">
//                                                                         <li>
//                                                                             <i className="fa-solid fa-gift text-green" />
//                                                                             For: {order.recipientName || "Special Recipient"}
//                                                                         </li>
//                                                                     </ul>
//                                                                 </div>
//                                                             </li>
//                                                             <li className="appointment-action">
//                                                                 <div className="detail-badge-info">
//                                                                     <span className="badge bg-success">
//                                                                         {order.status?.toUpperCase()}
//                                                                     </span>
//                                                                 </div>
//                                                             </li>
//                                                         </ul>
//                                                         <ul className="detail-card-bottom-info">
//                                                             <li><h6>Delivery Date</h6><span>{formatDate(order.deliveryDate)}</span></li>
//                                                             <li><h6>Delivery Time</h6><span>{formatTime(order.deliveryDate)}</span></li>
//                                                             <li><h6>Completed On</h6><span>{formatDate(order.updatedAt)}</span></li>
//                                                             {order.message && (
//                                                                 <li><h6>Fan's Message</h6><span>{order.message}</span></li>
//                                                             )}
//                                                         </ul>
//                                                     </div>

//                                                     <div className="col-md-4">
//                                                         <div className="video-preview-section">
//                                                             <h6 className="mb-3">Video Shoutout</h6>

//                                                             {isYouTube ? (
//                                                                 <div style={{
//                                                                     position: 'relative',
//                                                                     paddingBottom: '56.25%', // 16:9 aspect ratio
//                                                                     height: '0',
//                                                                     overflow: 'hidden',
//                                                                     borderRadius: '8px'
//                                                                 }}>
//                                                                     <iframe
//                                                                         src={`https://www.youtube.com/embed/${youtubeId}`}
//                                                                         title={`YouTube video for order ${order._id}`}
//                                                                         style={{
//                                                                             position: 'absolute',
//                                                                             top: '0',
//                                                                             left: '0',
//                                                                             width: 'relative',
//                                                                             height: '100%',
//                                                                             border: 'none',
//                                                                             borderRadius: '8px'
//                                                                         }}
//                                                                         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                                                                         allowFullScreen
//                                                                     />
//                                                                 </div>
//                                                             ) : (
//                                                                 <div className="text-center">
//                                                                     <div style={{
//                                                                         width: 'relative',
//                                                                         height: '140px',
//                                                                         backgroundColor: '#007bff',
//                                                                         borderRadius: '8px',
//                                                                         display: 'flex',
//                                                                         alignItems: 'center',
//                                                                         justifyContent: 'center',
//                                                                         color: 'white',
//                                                                         fontSize: '48px',
//                                                                         marginBottom: '10px'
//                                                                     }}>
//                                                                         <i className="fa-solid fa-play"></i>
//                                                                     </div>
//                                                                     <a
//                                                                         href={videoUrl}
//                                                                         target="_blank"
//                                                                         rel="noopener noreferrer"
//                                                                         className="btn btn-primary btn-sm"
//                                                                     >
//                                                                         <i className="fa-solid fa-external-link-alt me-1"></i>
//                                                                         View Video
//                                                                     </a>
//                                                                 </div>
//                                                             )}

//                                                             <div className="mt-3">
//                                                                 <input
//                                                                     type="text"
//                                                                     className="form-control form-control-sm"
//                                                                     value={videoUrl}
//                                                                     readOnly
//                                                                     onClick={(e) => e.target.select()}
//                                                                 />
//                                                                 <small className="form-text text-muted">
//                                                                     Click to copy video URL
//                                                                 </small>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         );
//                                     })}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <Footer {...props} />
//         </div>
//     );
// };

// export default CelebCompletedOrders;